export default function isOpera() {
  return navigator?.userAgent.includes('OPR');
}
